module.exports = __webpack_public_path__ + "img/9_hills.e149de4f.jpg";